import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ActivityTypeForm from '../../../components/forms/ActivityTypeForm';
import { useCreateActivityType } from '../../../hooks/useActivityTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ActivityTypeDTO } from '../../../services/apiClient';

const ActivityTypeCreate: React.FC = () => {
  const createMutation = useCreateActivityType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Activity Types', href: '/admin/activitytypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ActivityTypeDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/activitytypes');
    } catch (error) {
      console.error('Error creating ActivityType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/activitytypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ActivityType.Edit"
    >
      <ActivityTypeForm
        initialValues={{} as ActivityTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/activitytypes')}
      />
    </AdminLayout>
  );
};

export default ActivityTypeCreate;
